import { ResponsivePie } from "@nivo/pie";
import { useRef } from "react";

import { GovPlanSecretaryProject } from "../../../model/project";
import Masks from "../../../../../../../../shared/utils/mask.utils";
import {
    ProjectRoadmapItemDetails,
    ProjectRoadmapItemDetailsModalHandles,
} from "../../../components/roadmap-item/roadmap-item-details";

const customTooltip = ({
    original,
}: {
    original: GovPlanSecretaryProject["roadmap"][0];
}) => (
    <div
        style={{
            padding: "8px",
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "4px",
            color: "#333",
        }}
    >
        <strong>{original.name}</strong>
        <br />
        Status: {original.isCompleted() ? "Concluído ✅" : "Em andamento ⚠️"}
        <br />
        Data limite: {Masks.date(original.deadline.toISOString())}
    </div>
);

export const GovPlanSecretaryProjectProgressChart = ({
    project,
}: {
    project: GovPlanSecretaryProject;
}) => {
    const itemDetailsRef = useRef<ProjectRoadmapItemDetailsModalHandles>(null);

    const data = project.roadmap
        .sort((a, b) => (a.status > b.status ? 1 : 0))
        .map((it) => ({
            original: it,
            id: it.id,
            priority: it.priority,
            label: it.name,
            value: 1,
            status: it.status,
            completed: it.isCompleted(),
        }));

    const handleClick = (item: GovPlanSecretaryProject["roadmap"][0]) => {
        itemDetailsRef.current?.open({
            project: item,
            type: "view",
            projectId: item.projectId,
        });
    };

    return (
        <>
            <ResponsivePie
                data={data}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.5}
                padAngle={2}
                cornerRadius={3}
                colors={({ data: record }) =>
                    record.completed ? "green" : "yellow"
                }
                borderWidth={1}
                borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                arcLabel={({ label }) => label as string}
                arcLabelsTextColor={{
                    from: "color",
                    modifiers: [["darker", 2]],
                }}
                arcLinkLabel={({ data: record }) =>
                    `Prioridade ${record.priority}`
                }
                tooltip={(record) =>
                    customTooltip({ original: record.datum.data.original })
                }
                legends={[
                    {
                        anchor: "bottom",
                        direction: "row",
                        justify: false,
                        translateX: 0,
                        translateY: 56,
                        itemsSpacing: 0,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: "#999",
                        itemDirection: "left-to-right",
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: "circle",
                    },
                ]}
                onClick={(data$) => handleClick(data$.data.original)}
            />
            <ProjectRoadmapItemDetails ref={itemDetailsRef} />
        </>
    );
};
